export enum GridColTypeEnum {
	Link,
	Regular,
	Battery,
	Chip,
	Dayjs,
	Location,
	RowActions,
	LastOnline,
	TextBox,
}
